
//菜单列表select
import {
    axios
} from '@/utils/http.js'

//菜单列表
export function _MenuListAll(data) {
    return axios({
        url: '/v3/Menu/List_All',
        method: 'post',
        data: data
    })
}
export function _MenuGet(data) {
    return axios({
        url: '/v3/Menu/Get',
        method: 'post',
        data: data
    })
}

//菜单添加
export function _MenuAdd(data) {
    return axios({
        url: '/v3/Menu/Add',
        method: 'post',
        data: data
    })
}

//菜单编辑
export function _MenuEdit(data) {
    return axios({
        url: '/v3/Menu/Edit',
        method: 'post',
        data: data
    })
}

//菜单删除
export function _MenuDel(data) {
    return axios({
        url: '/v3/Menu/Del',
        method: 'post',
        data: data
    })
}
